import React from 'react';

/*
  Privacy — privacy policy page extracted from App.js.
  Props: goBack
*/
const Privacy = ({ goBack }) => {
  return (
        <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg)', paddingTop: '64px' }}>
          <div style={{ maxWidth: '640px', margin: '0 auto', padding: '64px 24px 120px' }}>

            {/* Back */}
            <button
              onClick={() => goBack('company')}
              style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', fontSize: '13px', fontWeight: 500, cursor: 'pointer', padding: 0, marginBottom: '48px', fontFamily: 'inherit', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--text-primary)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-tertiary)'}
            >← Back</button>

            <h1 style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 400, color: 'var(--text-primary)', lineHeight: 1.2, margin: '0 0 40px', letterSpacing: '-0.01em' }}>
              Privacy Policy
            </h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <p style={{ fontSize: '15px', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
                Axigon AI collects only the information you provide — account credentials, uploaded documents, and chat messages. This data is used solely to operate the service. We do not sell, rent, or share your personal data with third parties. Documents you upload are processed to generate insights and are not used to train external models.
              </p>
              <p style={{ fontSize: '15px', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
                We store data on servers located in India and the US. You can request deletion of your account and associated data at any time by writing to{' '}
                <a href="mailto:hello@axigonai.com" style={{ color: 'var(--accent)', textDecoration: 'none' }}>hello@axigonai.com</a>.
                This policy may be updated as the product evolves; continued use after changes constitutes acceptance.
              </p>
            </div>

          </div>
        </section>
  );
};

export default Privacy;
